module.exports = __webpack_public_path__ + "static/img/banner.6eb4b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/Warranty/banner.png
// module id = pPEw
// module chunks = 0